export function getClientFeatureFlagEnabled(client, flagKey) {
  if (typeof client?.featureFlagsMap === 'object' && client?.featureFlagsMap !== null && !Array.isArray(client.featureFlagsMap)) {
    return !!client.featureFlagsMap[flagKey]
  }

  if (Array.isArray(client?.featureFlags)) {
    const matchedFlag = client.featureFlags.find((flag) => String(flag?.flag_key ?? flag?.flagKey ?? '') === flagKey)
    const rawValue = matchedFlag?.is_active ?? matchedFlag?.isActive
    if (typeof rawValue === 'boolean') return rawValue
    if (rawValue === 1 || rawValue === '1') return true
    if (rawValue === 0 || rawValue === '0') return false
    return !!rawValue
  }

  if (typeof client?.featureFlags === 'object' && client?.featureFlags !== null) {
    return !!client.featureFlags[flagKey]
  }

  return false
}

export function mergeClientFeatureFlag(client, flagKey, isEnabled) {
  const normalizedEnabled = !!isEnabled
  const nextFeatureFlagsMap = {
    ...(typeof client?.featureFlagsMap === 'object' && client?.featureFlagsMap !== null && !Array.isArray(client.featureFlagsMap)
      ? client.featureFlagsMap
      : {}),
    [flagKey]: normalizedEnabled,
  }

  let nextFeatureFlags
  if (Array.isArray(client?.featureFlags)) {
    const existingIndex = client.featureFlags.findIndex((flag) => String(flag?.flag_key ?? flag?.flagKey ?? '') === flagKey)
    if (existingIndex >= 0) {
      nextFeatureFlags = client.featureFlags.map((flag, index) => index === existingIndex
        ? {
          ...flag,
          flag_key: flag?.flag_key ?? flag?.flagKey ?? flagKey,
          is_active: normalizedEnabled,
        }
        : flag)
    } else {
      nextFeatureFlags = [
        ...client.featureFlags,
        {
          flag_key: flagKey,
          is_active: normalizedEnabled,
        },
      ]
    }
  } else {
    nextFeatureFlags = {
      ...(typeof client?.featureFlags === 'object' && client?.featureFlags !== null ? client.featureFlags : {}),
      [flagKey]: normalizedEnabled,
    }
  }

  return {
    ...client,
    featureFlagsMap: nextFeatureFlagsMap,
    featureFlags: nextFeatureFlags,
  }
}

export function getClientFeatureFlagDisplayValue(client, flagKey) {
  return getClientFeatureFlagEnabled(client, flagKey) ? 'Enabled' : 'Disabled'
}

